<div
    class="z-50 absolute border-2 border-white bg-white rounded-full will-change-transform -translate-x-1/2 -translate-y-1/2 pointer-events-none mix-blend-difference size-20"
    id="cursor-follower"
></div>
